// Accessibility toolbar behaviour. Preferences are saved per browser (localStorage) and applied as
// classes on <html>; the inline script in snippets/accessibility-toolbar.liquid re-applies them early.
(() => {
  const root = document.documentElement;
  const toolbar = document.querySelector('[data-a11y-toolbar]');
  if (!toolbar) return;

  const toggle = toolbar.querySelector('[data-a11y-toggle]');
  const panel = toolbar.querySelector('[data-a11y-panel]');
  const TOGGLES = ['contrast', 'grayscale', 'links', 'font', 'motion'];
  const TEXT_MIN = -1;
  const TEXT_MAX = 3;

  const load = () => {
    try {
      return JSON.parse(localStorage.getItem('a11yPrefs') || '{}');
    } catch (e) {
      return {};
    }
  };
  const save = (prefs) => {
    try {
      localStorage.setItem('a11yPrefs', JSON.stringify(prefs));
    } catch (e) {}
  };

  let prefs = load();

  // Pause/resume the Slick image galleries and let other moving parts (countdown) check the class.
  const syncMotion = () => {
    const $ = window.jQuery;
    if (!$) return;
    $('.slick-initialized').each(function () {
      const slider = $(this);
      const autoplay = slider.slick('slickGetOption', 'autoplay');
      if (prefs.motion) {
        slider.data('a11yAutoplay', slider.data('a11yAutoplay') ?? autoplay);
        slider.slick('slickPause');
        slider.slick('slickSetOption', 'autoplay', false, false);
      } else if (slider.data('a11yAutoplay')) {
        slider.slick('slickSetOption', 'autoplay', true, false);
        slider.slick('slickPlay');
      }
    });
  };

  const apply = () => {
    for (let level = TEXT_MIN; level <= TEXT_MAX; level++) root.classList.remove(`a11y-text-${level}`);
    if (prefs.text) root.classList.add(`a11y-text-${prefs.text}`);
    TOGGLES.forEach((key) => {
      root.classList.toggle(`a11y-${key}`, !!prefs[key]);
      const btn = toolbar.querySelector(`[data-a11y-action="${key}"]`);
      if (btn) btn.setAttribute('aria-pressed', prefs[key] ? 'true' : 'false');
    });
    syncMotion();
    save(prefs);
  };

  const open = () => {
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    panel.querySelector('button').focus();
  };
  const close = () => {
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.focus();
  };

  toggle.addEventListener('click', () => (panel.hidden ? open() : close()));
  toolbar.querySelector('[data-a11y-close]').addEventListener('click', close);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) close();
  });
  document.addEventListener('click', (event) => {
    if (!panel.hidden && !toolbar.contains(event.target)) {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }
  });

  toolbar.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-a11y-action]');
    if (!btn) return;
    const action = btn.dataset.a11yAction;
    const text = prefs.text || 0;
    if (action === 'text-up') prefs.text = Math.min(TEXT_MAX, text + 1);
    else if (action === 'text-down') prefs.text = Math.max(TEXT_MIN, text - 1);
    else if (action === 'reset') prefs = {};
    else prefs[action] = !prefs[action];
    if (prefs.text === 0) delete prefs.text;
    apply();
  });

  // Slick initialises after page load; re-apply motion preference once it has.
  window.addEventListener('load', () => setTimeout(syncMotion, 300));
  apply();
})();
